import { Clock3, Download, Link2, SaveAll } from "lucide-react";

import { Button } from "@/components/ui/button";


export const ShareHistoryPanel = ({ history, onApplyTemplate, applyingTemplateId }) => {
  return (
    <section className="rounded-[28px] border border-stone-200 bg-white/90 p-4" data-testid="share-history-panel">
      <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-500" data-testid="share-history-kicker">
        Share-status detail
      </p>
      <h3 className="mt-2 text-lg font-semibold text-stone-900" data-testid="share-history-title">
        Bekijk je recente share-activiteit, templates en importstatus.
      </h3>

      <div className="mt-4 space-y-4">
        <div data-testid="share-history-created-section">
          <p className="text-sm font-semibold text-stone-900">Gedeelde weekmenu’s</p>
          <div className="mt-2 space-y-2">
            {(history?.created_shares || []).slice(0, 3).map((share) => (
              <div key={share.share_id} className="rounded-[20px] border border-stone-200 bg-stone-50 px-4 py-3" data-testid={`share-history-share-${share.share_id}`}>
                <p className="text-sm font-semibold text-stone-900">{share.title}</p>
                <div className="mt-2 flex flex-wrap gap-2 text-xs text-stone-600">
                  <span className="rounded-full bg-white px-3 py-1" data-testid={`share-history-share-code-${share.share_id}`}>Code {share.share_code}</span>
                  <span className="rounded-full bg-white px-3 py-1">{share.import_count} imports</span>
                  <span className="rounded-full bg-white px-3 py-1">{share.template_save_count} templates</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div data-testid="share-history-templates-section">
          <p className="text-sm font-semibold text-stone-900">Opgeslagen templates</p>
          <div className="mt-2 space-y-2">
            {(history?.templates || []).slice(0, 4).map((template) => (
              <div key={template.template_id} className="rounded-[20px] border border-stone-200 bg-stone-50 px-4 py-3" data-testid={`share-history-template-${template.template_id}`}>
                <p className="text-sm font-semibold text-stone-900">{template.title}</p>
                <p className="mt-2 text-xs text-stone-500" data-testid={`share-history-template-meta-${template.template_id}`}>Gebruikt {template.use_count} keer</p>
                <Button variant="outline" className="mt-3 rounded-full border-stone-200 bg-white" onClick={() => onApplyTemplate(template.template_id)} disabled={applyingTemplateId === template.template_id} data-testid={`share-history-template-apply-${template.template_id}`}>
                  <Download className="mr-2 h-4 w-4" />
                  Zet in planner
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div data-testid="share-history-activity-section">
          <p className="text-sm font-semibold text-stone-900">Recente activiteit</p>
          <div className="mt-2 space-y-2">
            {(history?.recent_activity || []).slice(0, 5).map((event) => (
              <div key={event.id} className="flex items-start gap-3 rounded-[20px] border border-stone-200 bg-stone-50 px-4 py-3" data-testid={`share-history-activity-${event.id}`}>
                {event.event_type === "share_created" ? <Link2 className="mt-0.5 h-4 w-4 text-emerald-700" /> : event.event_type === "template_saved" ? <SaveAll className="mt-0.5 h-4 w-4 text-amber-700" /> : <Clock3 className="mt-0.5 h-4 w-4 text-stone-500" />}
                <div>
                  <p className="text-sm font-medium text-stone-900">{event.title || event.template_title || "Share-activiteit"}</p>
                  <p className="mt-1 text-xs text-stone-500" data-testid={`share-history-activity-meta-${event.id}`}>{event.event_type} · {event.created_at}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};